const constants = require('./src/constants')

/** @type {import('next-i18next').UserConfig} */
module.exports = {
  i18n: {
    locales: ['default', ...constants.locales],
    defaultLocale: 'default',
    localeDetection: false,
  },
  ns: [
    'common',
    'sharedFlows_common',
    'sharedFlows_incomeProtection',
    'validation',
    'sharedFlows_privatePension',
    'sharedFlows_privateHealth',
    'sharedFlows_publicHealth',
    'sharedFlows_childSaving',
    'sharedFlows_termLife',
    'sharedFlows_petHealthTransferOptOut',
    'sharedFlows_petHealthTransferOptIn',
    'sharedFlows_travelHealth',
    'sharedFlows_legal',
    'sharedFlows_dental',
    'sharedFlows_contentsNxt',
    'sharedFlows_petHealth',
    'sharedFlows_petHealthV2',
    'sharedFlows_liabilityNxt',
    'sharedFlows_dogLiabilityNxt',
    'sharedFlows_householdAt',
    'sharedFlows_drone',
  ],
  serializeConfig: false,
  reloadOnPrerender: process.env.NODE_ENV === 'development',
  localePath: (locale, namespace) => {
    if (namespace.includes('sharedFlows_')) {
      const fileName = namespace.split('sharedFlows_')[1]
      return `../../packages/flows/src/configs/translations/${locale}/${fileName}Texts.json`
    }
    if (namespace === 'validation') {
      return `../../packages/validation/src/translations/${locale}/errors.json`
    }
    return `./public/locales/${locale}/${namespace}.json`
  },
  nonExplicitSupportedLngs: true,
}
